module.exports = __webpack_public_path__ + "static/media/gasoline-csm.a4196a35.png";